import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export default class ApiService {
  protected readonly _apiUrl: string;
  protected readonly _instance: AxiosInstance;

    constructor(apiUrl: string) {
    this._apiUrl = apiUrl;
    this._instance = axios.create({
      baseURL: this._apiUrl,
      timeout: 31000, // 31s timeout copied from web-admin project for consistency
      headers: { Accept: "application/json" },
    });
  }

  protected get<T = void>(endpoint: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._instance.get<T>(endpoint, config);
  }

  protected post<T = void>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._instance.post<T>(endpoint, data, config);
  }

  protected put<T = void>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._instance.put<T>(endpoint, data, config);
  }

  protected patch<T = void>(endpoint: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._instance.patch<T>(endpoint, data, config);
  }

  protected delete<T = void>(endpoint: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._instance.delete<T>(endpoint, config);
  }
}
